import type { useShopsStatsTrafficQuery } from '@fourthwall/module-analytics'

export const createChartDataConversionRates = (
  data:
    | NonNullable<
        NonNullable<
          ReturnType<typeof useShopsStatsTrafficQuery>['shopsStatsTrafficQuery']['data']
        >['current']['conversionRates']
      >['data' | 'predictedData']
    | undefined,
): {
  timestamps: string[]
  values: number[]
} => {
  if (!data) return { timestamps: [], values: [] }

  return {
    timestamps: data.timestamps,
    values: data.values.map((item) => item.checkoutPaid.percentage),
  }
}
